import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpRegionDonationsPage } from '@/features/marketPromotion/pages/MpRegionDonationsPage';
import { mpRegionDonationsSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/region-summary/donations')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.REGION_SUMMARY_VIEW),
  validateSearch: mpRegionDonationsSearchSchema,
  component: function MpRegionDonationsRoute() {
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Region-Wise Donations">
        <Suspense fallback={<PageLoader />}>
          <MpRegionDonationsPage search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
